import { Pipe, PipeTransform } from '@angular/core';
import { Roteiro } from '../../modelos/roteiro';

@Pipe({
  name: 'filtroRoteiros'
})
export class FiltroRoteirosPipe implements PipeTransform {

  transform(roteiros: Roteiro[], filtro?: string): any {
    if (roteiros === undefined || filtro === undefined || filtro.trim() === '') {
      return roteiros;
    }
    filtro = filtro.toLocaleLowerCase();
    return roteiros.filter(roteiro => roteiro.descricaoRoteiro.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-roteiros.pipe.ts